import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { pxToRem } from "../../styles/utils";

const actionStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: max-content;
  min-height: ${pxToRem(32)};
  padding: ${pxToRem(8)} ${pxToRem(14)};
  border: ${pxToRem(1.25)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: ${pxToRem(8)};
  background: transparent;
  color: ${({ theme }) => theme.colors.ink};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${pxToRem(13)};
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => theme.colors.brandSubtle};
  }

  &:focus-visible {
    outline: ${pxToRem(2.5)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2.5)};
  }
`;

export const InternalActionLink = styled(Link)`
  ${actionStyles}
`;

export const ExternalActionLink = styled.a`
  ${actionStyles}
`;

export const ActionButton = styled.button`
  ${actionStyles}
`;

export const DisabledAction = styled.span`
  ${actionStyles}
  color: ${({ theme }) => theme.colors.inkMuted};
  border-color: ${({ theme }) => theme.colors.inkBorder};
  cursor: default;

  &:hover {
    color: ${({ theme }) => theme.colors.inkMuted};
    border-color: ${({ theme }) => theme.colors.inkBorder};
    background: transparent;
  }
`;
